module.exports = "/* You can add global scripts to this file, and also import other scripts files */\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/raw-loader!C:/Users/Pablo/source/repos/prote/angular/~/source-map-loader!C:/Users/Pablo/source/repos/prote/angular/src/assets/scripts.js
// module id = ../../../../raw-loader/index.js!../../../../source-map-loader/index.js!../../../../../src/assets/scripts.js
// module chunks = 18